<template>
  <div>
    <div class="header">
      <el-row type="flex" justify="space-between" align="middle">
        <div>
          <span class="title">新品预销</span>
          <select-year v-model="form.year" @change="handleYearChange"></select-year>
          <select-store v-model="form.storeId" @change="handleStoreChange"></select-store>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import selectYear from '@/views/preSalePlanNew/components/headerSelectBar/components/selectYear/selectYear'
import selectStore from '@/views/preSalePlanNew/components/headerSelectBar/components/selectStore/selectStore'

export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData'],
  components: {
    selectYear, selectStore
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    formData: {
      handler (val) {
        this.form = {...val};
      },
      immediate: true,
      deep: true
    },
    form: {
      handler(val) {
        if(JSON.stringify(val) !== JSON.stringify(this.formData)) {
          this.$emit('input', val);
        }
      },
      deep: true
    }
  },
  methods: {
    handleYearChange(data) {
      this.$emit('change', {...this.form, year: data});
    },
    handleStoreChange(data) {
      this.$emit('change', {...this.form, storeId: data});
    }
  }
}
</script>

<style lang="stylus" scoped>
  .header
    background #ffffff
    padding 10px
    border-radius 4px
  
  >>> .el-link.el-link--primary
    margin-left 15px

  .title
    font-size 14px
    font-weight bold
    color #555
    display inline-block
    margin-right 10px
</style>
